import { createSelector } from 'reselect';
import { entries, get, reduce } from 'lodash/fp';

function getPlayerBonuses(bonuses = {}, bonusesChosen = {}) {
  return reduce(
    (memo, [key, value]) => ({
      ...memo,
      [value]: bonuses[key]
    }),
    {},
    entries(bonusesChosen)
  );
}

const playerBonusesSelector = createSelector(
  get('challenge.bonuses'),
  get('lineUp.bonusesChosen'),
  getPlayerBonuses
);

export default playerBonusesSelector;
